module.exports = __webpack_public_path__ + "img/salon41.d25f231a.png";